module.exports = __webpack_public_path__ + "static/media/icon-file-upload.f9dfdcfd.svg";